module.exports = __webpack_public_path__ + "assets/img/service1.2b2e82f9.png";